export default "__VITE_ASSET__B$HPpxmz__"